module.exports = __webpack_public_path__ + "img/colel-hamesh-login.0e65effe.jpg";